import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { StoreService } from 'src/app/core/store.service';
import { ProgressBarService } from '../../core/progress-bar.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { School } from '../../models/school.model';
import { SchoolSystem } from '../../models/state.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent {
  title = 'home.title';
  schools: Array<School> = [];

  constructor(private router: Router,
    private route: ActivatedRoute,
    private store: StoreService,
    private progress: ProgressBarService,
    private navigation: NavigationService) {
  }

  nextJcps() {
    this.store.state.schoolSystem = SchoolSystem.Jcps;
    this.router.navigate([this.navigation.home.next]);
  }

  nextMadison() {
    this.store.state.schoolSystem = SchoolSystem.Madison;
    this.router.navigate([this.navigation.home.next]);
  }

}
